// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateSpvModal_title__3xZNY","form":"CreateSpvModal_form__14koh","formTitle":"CreateSpvModal_formTitle__3WChP"};